import firebase from 'firebase';

const firebaseConfig = {
    apiKey: 'AIzaSyC4UDclmny_QbKeoydL2w-j86y5f3iNA8Y',
    authDomain: 'vue-qms-ff349.firebaseapp.com',
    databaseURL: 'https://vue-qms-ff349.firebaseio.com',
    projectId: 'vue-qms-ff349',
    storageBucket: 'vue-qms-ff349.appspot.com',
    messagingSenderId: '874469696420',
    appId: '1:874469696420:web:eea4470e54b6bce4a09731'
};

firebase.initializeApp(firebaseConfig);
